module.exports = __webpack_public_path__ + "static/media/payment-qr.f44382c6.png";